import React from 'react';
import { useTranslation } from 'react-i18next';
import RedemptionsTable from '../../components/RedemptionsTable';

/**
 * 兑换码管理页面容器
 * 修改时间：2026-06-12
 */
const Redemption = () => {
  const { t } = useTranslation();
  return <RedemptionsTable />;
};

export default Redemption;
